// The cookie key used for storing subscriptions
export const SUBSCRIPTIONS_KEY = 'subscriptions'

// The amount of discount to expect from ordergroove
export const SUBSCRIPTION_DISCOUNT_PERCENTAGE = 15
